<template>
  <div class="verify-2fa">
    <Loader v-if="loading" />
    
    <div v-else class="content-container">
      <div class="logo">
        <img
          src="@/assets/images/wtiogomark_ra.png"
          alt="logo"
          class="img-fluid"
        />
      </div>
      <div
        v-if="errors.length"
        class="alert alert-danger"
        role="alert"
      >
        <span
          v-for="(message, index) in errors"
          :key="index"
          v-html="message"
        ></span>
      </div>

      <div v-if="errors.length" class="button-container">
        <button class="btn btn-teal" @click="goToLogin">
          ログイン画面へ戻る
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/config/api';
import Loader from './Loader.vue';

export default {
  name: 'VerifyTwoFA',
  components: { Loader },
  data() {
    return {
      errors: [],
      loading: true,
    };
  },
  methods: {
    async verifyToken() {
      const { token } = this.$route.query;
      
      if (!token) {
        this.errors = ['認証トークンが提供されていません。'];
        this.loading = false;
        return;
      }

      try {
        const response = await this.axios.get(Api.url(Api.endpoints.VERIFY_2FA), {
          params: { token },
        });
        
        // Set the auth token and redirect
        this.$auth.setToken(response.data);
        this.$router.push('/');
        
      } catch (error) {
        console.error('2FA verification error:', error);
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    
    handleError(error) {
      this.errors = ['有効な本人確認用URLではありませんでした。<br/>再度ログイン実施をお願いします。'];
    },
    
    goToLogin() {
      this.$router.push('/login');
    },
  },

  async mounted() {
    await this.verifyToken();
  },
};
</script>

<style scoped>
.verify-2fa {
  text-align: center;
  padding: 50px;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content-container {
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

.logo {
  margin-bottom: 20px;
}

.img-fluid {
  width: 200px;
  height: auto;
}

.alert-danger {
  margin-bottom: 0;
  font-size: 16px;
  border-radius: 8px;
  padding: 20px 30px;
  text-align: left;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
  width: 100%;
  max-width: 400px;
  margin-bottom: 30px;
}

.btn-teal {
  background-color: #006c6b;
  border-radius: 8px;
  color: #fff;
  padding: 15px 40px;
  font-size: 16px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
  min-width: 300px;
}

.btn-teal:hover {
  background-color: #005a59;
}
.logo {
  margin-bottom: 30px;
}

.img-fluid {
  width: 200px;
  height: auto;
}

@media (max-width: 768px) {
  .verify-2fa {
    padding: 20px;
  }
  
  .alert-danger {
    font-size: 12px;
    padding: 15px 20px;
    max-width: 350px;
  }
  
  .btn-teal {
    padding: 12px 30px;
    font-size: 14px;
    min-width: 250px;;
  }
}
</style> 